import { CSSProperties, useState } from 'react';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { Color } from '@vivli/shared/theme';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { finalize, first } from 'rxjs/operators';
import { useActiveUserContext, useDataRequestsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { badgeStyle } from './badge.style';
import { DTIDuaValidationButton } from '@vivli/shared/infrastructure/constants';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxHeight: 40,
};

const approvedTextStyle: CSSProperties = {
    backgroundColor: Color.VIVLI_GREEN,
    color: Color.WHITE,
    ...badgeStyle,
};

export const DuaValidationButtonView = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { dataRequest, updateDataRequest, setIsUpdatingStatus, isUpdatingStatus } = useDataRequestContext();

    const { setDataRequestStatus } = useDataRequestsApiContext();
    //TODO PERMFE - redo with permissions+
    const isVivliAdmin = useActiveUserContext().hasPermission(PermissionsEnum.DrActAdv);
    const modalService = useModalApiContext();

    const updateLoadingStatus = (status: boolean) => {
        setIsUpdatingStatus(status);
        setIsLoading(status);
    };

    const handleDuaValidationClick = () => {
        updateLoadingStatus(true);
        setDataRequestStatus(dataRequest.id, DataRequestStatusEnum.AwaitingDUAValidation, ' Begin DUA Validation')
            .pipe(
                first(),
                finalize(() => updateLoadingStatus(false))
            )
            .subscribe(updateDataRequest, modalService.error);
    };

    return (
        <div style={containerStyle}>
            <span style={approvedTextStyle}> Approved</span>
            {isVivliAdmin && (
                <AdminHeaderButtonView
                    style={{ marginLeft: 10 }}
                    title={'Begin DUA Validation'}
                    isLoading={isLoading}
                    isDisabled={isUpdatingStatus}
                    onClick={handleDuaValidationClick}
                    dataId={DTIDuaValidationButton.DataRequestBeginDuaValidationButton}
                />
            )}
        </div>
    );
};
